function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9475 15.9597L17.1851 15.7015C18.5634 14.2034 19.3415 12.2483 19.3415 10.1707C19.3415 5.65816 15.6833 2 11.1707 2C6.65816 2 3 5.65816 3 10.1707C3 14.6833 6.65816 18.3415 11.1707 18.3415C12.6696 18.3415 14.1084 17.9376 15.3655 17.184L15.6104 17.0372L20.3232 21.75C20.6566 22.0833 21.1971 22.0833 21.5305 21.75C21.8638 21.4166 21.8638 20.8761 21.5305 20.5427L16.9475 15.9597ZM11.1707 16.6341C7.60109 16.6341 4.70732 13.7404 4.70732 10.1707C4.70732 6.60109 7.60109 3.70732 11.1707 3.70732C14.7404 3.70732 17.6341 6.60109 17.6341 10.1707C17.6341 13.7404 14.7404 16.6341 11.1707 16.6341Z",
  fill: "white"
});

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2ff1717a.svg";
export { ForwardRef as ReactComponent };